import gql from "graphql-tag";
import { HOTEL_FRAGMENT } from '../fragment/hotel';

export const GET_SECTOR_HOTELS = gql`
    query getSectorHotels($uuid: String!, $sectorId: Int!){
        getSectorHotels(uuid: $uuid, sectorId: $sectorId){
            ...HotelFragment
        }
    } 
    ${HOTEL_FRAGMENT}
`;


export const GET_CITY_HOTELS = gql`
   query getCityHotels($city: String!, $date: String!, $nights: Int!, $currency: String!){
        getCityHotels(city: $city, date: $date, nights: $nights, currency: $currency){
            ...HotelFragment
        }
    } 
    ${HOTEL_FRAGMENT}
`;
